import { Button, Form, Input } from 'antd';
import React from 'react';
import { useForm, withForm } from 'react-antd-formutil';
import { useNavigate } from 'react-router-dom';
import Card, { CardButtonWrap } from 'components/Card';
import FormItem from 'components/FormItem';
import Toast from 'components/Toast';
import Track from 'components/Track';
import require2FA from 'utils/require2FA';
import store from '../../../store';
import './style.scss';

const Uninstall: React.FC = () => {
    const $formutil = useForm<{ login_password: string }>();
    const navigate = useNavigate();
    const onSubmit = async (otp_code?: string) => {
        try {
            const { $invalid, $batchDirty, $params, $getFirstError } = $formutil;

            if ($invalid) {
                const firstError = $getFirstError();

                Toast.show(firstError);
                $batchDirty(true);

                return;
            }

            Toast.loading(true);

            const params: {
                login_password: string;
                otp_code?: string;
            } = $params;

            if (otp_code) {
                params.otp_code = otp_code;
            }

            const ret = await store.off2fa(params);

            Toast.loading(false);

            if (ret.is_succ) {
                Toast.show(__('两步验证关闭成功'));
                store.updateOtpEnable(false);
                navigate('/profile/security', { replace: true });
            } else {
                Toast.show(__('两步验证关闭失败'));
            }
        } catch (error) {
            Toast.loading(false);

            let showToast = true;

            const { error_code, error_msg } = error;

            // 需要两步验证token
            if (error_code >= 11401 && error_code <= 11402) {
                showToast = false;

                if (error_code === 11402) {
                    showToast = true;
                }

                require2FA()
                    .then(code => {
                        onSubmit(code);
                    })
                    .catch(e => {
                        Toast.show(e.message);
                    });
            }

            if (showToast) {
                Toast.show(error_msg || error.message);
            }
        }
    };

    return (
        <div className="fa-uninstall-page">
            <Card form>
                <h2>{__('关闭两步验证')}</h2>
                <h4 className="text-left">{__('为确保安全，关闭两步验证前需验证登录密码')}</h4>
                <Form layout="vertical" noValidate onFinish={() => onSubmit()}>
                    <FormItem
                        label={__('登录密码')}
                        name="login_password"
                        required
                        validMessage={{ required: __('请输入登录密码') }}>
                        <Input type="password" placeholder={__('请输入登录密码')} />
                    </FormItem>

                    <CardButtonWrap>
                        <Track eventModel="安全中心" eventType="两步验证_关闭" eventName="两步验证开启_登录密码">
                            <Button block size="large" type="primary" htmlType="submit">
                                {__('确定')}
                            </Button>
                        </Track>
                    </CardButtonWrap>
                </Form>
            </Card>
        </div>
    );
};

export default withForm(Uninstall);
